import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, Calendar, Mail, Phone, ChevronDown, X } from 'lucide-react';
import API from '../lib/api';

export default function FloatingContact() {
  const [open, setOpen] = useState(() => window.innerWidth >= 1024);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    API.get('/site-settings').then(r => setSettings(r.data?.site || {})).catch(() => {});
  }, []);

  const phone = settings.phone || '+14165550100';
  const email = settings.contact_email || 'info@plushresidence.ca';

  const items = [
    { icon: MessageCircle, label: 'Chat with us', action: () => window.open(`https://wa.me/${phone.replace(/\D/g, '')}`, '_blank'), color: 'text-emerald-500' },
    { icon: Calendar, label: 'Book a tour', action: () => window.location.href = '/contact', color: 'text-blue-500' },
    { icon: Mail, label: 'Email an agent', action: () => window.location.href = `mailto:${email}`, color: 'text-amber-500' },
    { icon: Phone, label: 'Call or text us', action: () => window.location.href = `tel:${phone}`, color: 'text-rose-500' },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-2" data-testid="floating-contact">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="flex flex-col gap-2 mb-2"
          >
            {items.map((item, i) => (
              <motion.button
                key={i}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                transition={{ delay: i * 0.05 }}
                onClick={item.action}
                className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 shadow-lg shadow-black/10 hover:shadow-xl hover:scale-[1.02] transition-all duration-200 min-w-[200px] group border border-stone-100"
                data-testid={`contact-option-${i}`}
              >
                <div className="w-9 h-9 rounded-lg bg-stone-50 flex items-center justify-center group-hover:bg-stone-100 transition-colors">
                  <item.icon className={`w-4.5 h-4.5 ${item.color}`} />
                </div>
                <span className="text-sm font-medium text-stone-700 flex-1 text-left">{item.label}</span>
                <ChevronDown className="w-3.5 h-3.5 text-stone-300 -rotate-90" />
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setOpen(!open)}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${
          open ? 'bg-stone-800 shadow-stone-800/30' : 'bg-gold shadow-gold/30'
        }`}
        data-testid="floating-contact-toggle"
      >
        {open ? <X className="w-5 h-5 text-white" /> : <MessageCircle className="w-5 h-5 text-white" />}
      </motion.button>
    </div>
  );
}
